import { render } from "./alert.md?vue&type=template&id=5fc19100"
import script from "./alert.md?vue&type=script&lang=js"
export * from "./alert.md?vue&type=script&lang=js"
script.render = render

export default script